<template>
  <div class="scenario-container">
    <el-row>
      <el-col :span="isGeneralAdmin || hasFilter ? 12 : 24">
        <organization-breadcrumb
          :items="[$t('study_sets.curriculum'), $t($i18nLabelsHelper(currentOrganizationType, 'ai_role_plays'))]"
        />
      </el-col>
      <el-col v-if="isGeneralAdmin || hasFilter" :span="12">
        <admin-organization-switcher />
      </el-col>
    </el-row>
    <div class="scenario-tab-body">
      <curriculum-menu :active-entry="`/organization/${organizationId}/scenarios`" />
      <div class="filter-section">
        <div class="filter-group">
          <label class="filter-title">
            {{ $t("homework.create_assignment.filter_by_english_level") }}
          </label>
          <el-checkbox-group class="elsa-checkbox-group checkbox-filter" v-model="checkCerfLevelScenario">
            <el-checkbox class="elsa-checkbox" label="A1">
              {{ $t("homework.create_assignment.level_novice") }}
            </el-checkbox>
            <el-checkbox class="elsa-checkbox" label="A2">
              {{ $t("homework.create_assignment.level_upper_beginner") }}
            </el-checkbox>
            <el-checkbox class="elsa-checkbox" label="B1">
              {{ $t("homework.create_assignment.level_lower_intermediate") }}
            </el-checkbox>
            <el-checkbox class="elsa-checkbox" label="B2">
              {{ $t("homework.create_assignment.level_upper_intermediate") }}
            </el-checkbox>
            <el-checkbox class="elsa-checkbox" label="C1">
              {{ $t("homework.create_assignment.level_advanced") }}
            </el-checkbox>

            <el-checkbox class="elsa-checkbox" label="easy">
              {{ $t("homework.create_assignment.easy") }}
            </el-checkbox>

            <el-checkbox class="elsa-checkbox" label="medium">
              {{ $t("homework.create_assignment.medium") }}
            </el-checkbox>

            <el-checkbox class="elsa-checkbox" label="hard">
              {{ $t("homework.create_assignment.hard") }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <!-- <div class="filter-group">
          <label class="filter-title">
            {{ $t("ai_tutor.ent.filter_by_level") }}
          </label>
          <el-checkbox-group class="elsa-checkbox-group checkbox-filter" v-model="checkCerfLevelScenario">
          </el-checkbox-group>
        </div> -->
        <div v-if="isLoading" class="filter-section__overlay"></div>
      </div>
      <div class="skills-section">
        <base-table-loading v-if="isLoading" :data="skeletonData" />
        <assignment-scenarios v-show="!isLoading" :data="scenarioFilter" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";
import CurriculumMenu from "@/components/studysets/CurriculumMenu";
import AdminOrganizationSwitcher from "@/components/dashboard/AdminOrganizationSwitcher";
import AssignmentScenarios from "@/components/homeworks/create-assignments/AssignmentScenarios";
import BaseTableLoading from "@/components/common/BaseTableLoading.vue";
import { K12 } from "@/constants/organizationType";

export default {
  components: {
    BaseTableLoading,
    OrganizationBreadcrumb,
    CurriculumMenu,
    AdminOrganizationSwitcher,
    AssignmentScenarios,
  },
  data() {
    return {
      scenarios: [],
      scenarioFilter: [],
      checkCerfLevelScenario: [],
      isLoading: false,
      skeletonData: [
        {
          name: "",
          label: "",
          layout: [
            {
              width: "40%",
              justifyContent: "left",
              alignItems: "left",
              items: [
                {
                  width: "400px",
                  height: "10px",
                },
                {
                  width: "200px",
                  height: "10px",
                },
              ],
            },
          ],
        },
        {
          name: "",
          label: "",
          layout: [],
        },
        {
          name: "",
          label: "",
          layout: [],
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      isGeneralAdmin: "organization/isGeneralAdmin",
      hasFilter: "organization/hasFilter",
      organizationId: "organization/currentOrganizationId",
      currentOrganizationType: "organization/currentOrganizationType",
    }),
    isK12Org() {
      return this.currentOrganizationType === K12;
    },
  },
  methods: {
    getScenarios() {
      this.isLoading = true;
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/scenarios`)
        .then(response => {
          this.scenarios = response.data;
          this.scenarioFilter = this.scenarios;
        })
        .catch(error => {
          throw error;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  async mounted() {
    await this.getScenarios();
  },
  watch: {
    checkCerfLevelScenario: {
      handler: function(val) {
        if (!val.length) {
          this.scenarioFilter = this.scenarios;

          return;
        }
        const listTagFilter = val.reduce((result, curr, index, arr) => {
          curr.split(",");
          return [...result, ...curr.split(",")];
        }, []);

        this.scenarioFilter = this.scenarios.filter(scenario => {
          return listTagFilter.includes(scenario.level);
        });
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.scenario-container {
  width: 100%;
  font-family: "SF Pro Display", sans-serif;
  .scenario-tab-body {
    // text-align: center;
    padding: 24px 40px 0;
  }
  .filter-section {
    position: relative;
    width: 100%;
    min-height: 104px;
    background: #efeff4;
    border-radius: 12px;
    margin: 20px 0px;

    &__overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.5);
      z-index: 1;
    }
    .filter-group {
      padding: 16px 24px;
    }
    .filter-title {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.25px;
      color: #8e8e93;
    }
    .checkbox-filter {
      flex-direction: revert;
      padding-top: 5px;
    }
    ::v-deep .elsa-checkbox-group .elsa-checkbox .el-checkbox__label {
      font-weight: normal !important;
      font-size: 16px !important;
      line-height: 24px !important;
      letter-spacing: 0.25px !important;
      color: #121131 !important;
    }
  }

  ::v-deep .elsa-ai-lesson {
    width: 40px;
  }

  ::v-deep .base-table-loading {
    padding: 0;
    .el-table__header-wrapper {
      display: none;
    }
  }
}
</style>
